import Navbar from './Navbar';
export { default as NavbarV2 } from './NavbarV2';
export default Navbar;
//# sourceMappingURL=index.js.map